import { DataService, ApiService, UserService } from "../service"
export enum DataFileType {
  sample = 1 , //样本图 ,
  drawing = 2 ,//外形尺寸图 
  images = 3 ,//模型图(产品图册) 
  model = 8 , //模型及图纸 
  document = 9 //相关资料
}

export interface ProductListParams {
  page: number,
  pageSize: number,
  q?: string, // 检索条件
  compId: string, // 企业id
  dirId: number, // 企业自定义目录id
  sort?: number, // 排序（1：综合 4：访问量 6：下载）
};

export class ProductService{
  //详情
  static async getInfo(ProdID:number) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/GetSInfo?prodId=${ProdID}`, {}, { offErrorMsg: true });
  }
  static async getProdIntro(ProdID:number) {
    return await DataService.get(`${ApiService.EngineerApi}/prod/getProdInfo?prodId=${ProdID}`);
  }
  static async getProdInfo(ProdID:number) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/GetProdInfo?ProdID=${ProdID}`);
  }
  static async getDetailInfo(ProdID:number) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/GetDetailInfo?prodId=${ProdID}`);
  }
  // -1 全部 1 Logo  2 产品图册 3 样本图 4模型图纸 5相关资料
  static async getFiles(ProdID:number,FileType:number = -1) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/GetFiles?ProdID=${ProdID}&FileType=${FileType}`);
  }
  //获取选型参数
  static async getLec(ProdID:number ) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/GetLectotypeParams?prodId=${ProdID}`);
  }
  // 选择选型参数过滤
  static async filterLectotypeParams(ProdId:number, data: any []) {
    return await DataService.post(`${ApiService.JrzzApi}/prod/FilterLectotypeParams?ProdID=${ProdId}`, data);
  }
  //获取选型参数
  static async buildStepFile(ProdID:number, skuName: string) {
    return await DataService.post(`${ApiService.JrzzApi}/prod/BuildStepFile?prodId=${ProdID}&skuName=${skuName}`);
  }

  // 判断模型是否存在
  static async stepExist(ProdID:number,SkuName:string) {
    return await DataService.get(`${ApiService.JrzzApi4}/api/Download/StepExist?prodid=${ProdID}&skuname=${SkuName}`);
  }
  //通知服务器生成通用模型
  static async SaveStepJson(SkuName:string, ProdID: string, SelConfigs: any) {
    return await DataService.post(`${ApiService.JrzzApi4}/api/Download/SaveStepJson?userId=${UserService.userID()}&SkuName=${encodeURIComponent(SkuName)}`, {
      ProdID,
      SelConfigs,
    });
  }

  // 检查产品是否已收藏
  static async existProdFavorite(ProdID:number) {
    return await DataService.get(`${ApiService.JrzzApi}/favorite/prod/exists?prodId=${ProdID}`);
  }
  //收藏产品
  static async insertProdFavorite(ProdID:number, DirId: number = 0) {
    return await DataService.post(`${ApiService.JrzzApi}/data/2205/205/add?dirId=${DirId}&prodId=${ProdID}`, {ProdID});
  }

  // 检查是否可下载
  static async downloadCheck(ProdID:number) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/download/check?prodId=${ProdID}`);
  }

  /**
   * 检查中间模型是否存在
   * @param prodId 
   * @param skuId 
   * @param fileName 
   * @returns 
   */
  static async stepFileExist(prodId: number, skuId: number, fileName: string) {
    return await DataService.get(`${ApiService.JrzzApi}/prod/download/exist/${prodId}/${skuId}?fileName=${fileName}`);
  }

  // 从solr中获取产品信息列表
  static async prodGetSlist(params: ProductListParams) {
    let url = `${ApiService.JrzzApi}/prod/GetSList`;
    Object.keys(params).forEach((item, index) => {
      const tags = index === 0 ? '?' : '&';
      // @ts-ignore
      url = `${url}${tags}${item}=${params[item]}`;
    })
    return await DataService.get(url);
  }

  static async getList(Page:number = 1 , Keywords : string = '' , SID : number = 0 , CID:number = 0, pageSize :number = 10, OrderBy :string =  'CreateDate',state:number = -1) {
    return await DataService.post(`${ApiService.JrzzApi}/prod/GetList`,{
      PageSize: pageSize,
      Page: Page,
      Keywords: Keywords,
      OrderBy: OrderBy,
      SID: SID,
      CID:CID,
      State:state
    });
  }

  /**设置产品选型信息 */
  static async setProdParams(key: string, json: any) {
    return await DataService.post(`${ApiService.EngineerApi}/prod/setProdParams`,{ key, json: JSON.stringify(json) });
  }
}